// BlogLayoutNews.tsx
import React from 'react';
import Image from 'next/image';
import { Post } from '../PostType'; // Assurez-vous que ce type est correctement défini

interface BlogLayoutNewsProps {
    post: Post;
}

const BlogLayoutNews: React.FC<BlogLayoutNewsProps> = ({ post }) => {
    // Structure de mise en page spécifique pour les articles 'news'
    return (
        <article className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="md:flex">
                <div className="md:shrink-0">
                    <Image
                        src={post.imageUrl}
                        alt={`Cover Image for ${post.title}`}
                        width={768}
                        height={432}
                        layout="responsive"
                        className="object-cover"
                    />
                </div>
                <div className="p-8">
                    <div className="uppercase tracking-wide text-sm text-indigo-500 font-semibold">{post.category.join(', ')}</div>
                    <a href="#" className="block mt-1 text-lg leading-tight font-medium text-black hover:underline">{post.title}</a>
                    <p className="mt-2 text-gray-500">{post.summary}</p>
                    <div className="mt-4">
                        {post.content.sections && post.content.sections.map((section, index) => (
                            <div key={index}>
                                <h2 className="text-xl font-bold">{section.h2}</h2>
                                <p className="mt-2">{section.paragraph}</p>
                            </div>
                        ))}
                    </div>
                    <div className="mt-4">
                        <span className="font-bold">Written by:</span> {post.author}
                        <span className="mx-2">|</span>
                        <time dateTime={post.date}>{post.date}</time>
                    </div>
                </div>
            </div>
        </article>
    );
};

export default BlogLayoutNews;
